import { AfterViewInit, Component, OnDestroy, OnInit, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { GetErrorMessageTranslationedValue, WebApiResponseBase } from "@shared/classes/general";
import { Utilities } from "@shared/utils/utilities";

@Component({
  selector: 'app-based',
  template: ''
})
export abstract class BasedComponent implements OnInit, OnDestroy {
  destroy$ = new Subject();
  translateService = inject(TranslateService);

  constructor() { }

  ngOnInit(): void {
  }

  getErrorMessages = (errorResponses: WebApiResponseBase[]) => {
    return errorResponses.map(errorResponse => this.getErrorMessage(errorResponse)).filter(msg => !Utilities.isEmptyString(msg));
  }

  getErrorMessage = (errorResponse: WebApiResponseBase) => {
    if (!errorResponse) {
      return "";
    }

    return GetErrorMessageTranslationedValue(errorResponse, this.translateService);
  }

  getAndReplaceTranslatedMessge = (transId: string, replaceMsgTag: string, replacedMsg: string) => {
    return this.translateService.instant(transId).replace(replaceMsgTag, replacedMsg);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
